export default __webpack_public_path__ + "static/media/refining.610a041f.jpg";